import { DTOProfileCardType } from 'src/apis/dto/DTOProfileCard';

export const DM_REPORT_TYPE_TYPES = [
  'SEXUAL_ABUSE',
  'FRAUD_ABUSE',
  'INSULT_ABUSE',
  'PROFILE_ABUSE',
  'DSA_ILLEGAL_CONTENT',
] as const;
export type DMReportType = (typeof DM_REPORT_TYPE_TYPES)[number];

export const REPORT_TYPE_TYPES = [
  'IMAGE_PROFILE_ABUSE',
  'VIDEO_PROFILE_ABUSE',
  'BIO_NICKNAME_ABUSE',
  'UNDERAGE_USER',
  'FAKE_GENDER_ABUSE',
  'OTHER_ABUSE',
  'DSA_ILLEGAL_CONTENT',
] as const;
export const REPORT_ALL = [...REPORT_TYPE_TYPES];
export const REPORT_EXCEPT_DSA = REPORT_TYPE_TYPES.filter((type) => type !== 'DSA_ILLEGAL_CONTENT');

export type ReportType = (typeof REPORT_TYPE_TYPES)[number];

const MATCH_REPORT_TYPE_TYPES = [
  'VISUAL_ABUSE',
  'VERBAL_ABUSE',
  'BIO_NICKNAME_ABUSE',
  'CHILD_AGE_ABUSE',
  'VIDEO_PROFILE_ABUSE',
  'FAKE_GENDER_ABUSE',
  'DSA_ILLEGAL_CONTENT',
] as const;
export type MatchReportType = (typeof MATCH_REPORT_TYPE_TYPES)[number];

export enum DSAContentType {
  PROFILE_IMAGE = 'PROFILE_IMAGE',
  NICKNAME = 'NICKNAME',
  BIO = 'BIO',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
}

export enum DSACategoryType {
  DSA_CATEGORY_ANIMAL_WELFARE = 'DSA_CATEGORY_ANIMAL_WELFARE',
  DSA_CATEGORY_DATA_PROTECTION_AND_PRIVACY_VIOLATIONS = 'DSA_CATEGORY_DATA_PROTECTION_AND_PRIVACY_VIOLATIONS',
  DSA_CATEGORY_ILLEGAL_OR_HARMFUL_SPEECH = 'DSA_CATEGORY_ILLEGAL_OR_HARMFUL_SPEECH',
  DSA_CATEGORY_INTELLECTUAL_PROPERTY_INFRINGEMENTS = 'DSA_CATEGORY_INTELLECTUAL_PROPERTY_INFRINGEMENTS',
  DSA_CATEGORY_NEGATIVE_EFFECTS_ON_CIVIC_DISCOURSE_OR_ELECTIONS = 'DSA_CATEGORY_NEGATIVE_EFFECTS_ON_CIVIC_DISCOURSE_OR_ELECTIONS',
  DSA_CATEGORY_NON_CONSENSUAL_BEHAVIOUR = 'DSA_CATEGORY_NON_CONSENSUAL_BEHAVIOUR',
  DSA_CATEGORY_ONLINE_BULLYING_INTIMIDATION = 'DSA_CATEGORY_ONLINE_BULLYING_INTIMIDATION',
  DSA_CATEGORY_PORNOGRAPHY_OR_SEXUALIZED_CONTENT = 'DSA_CATEGORY_PORNOGRAPHY_OR_SEXUALIZED_CONTENT',
  DSA_CATEGORY_PROTECTION_OF_MINORS = 'DSA_CATEGORY_PROTECTION_OF_MINORS',
  DSA_CATEGORY_RISK_FOR_PUBLIC_SECURITY = 'DSA_CATEGORY_RISK_FOR_PUBLIC_SECURITY',
  DSA_CATEGORY_SCAMS_AND_OR_FRAUD = 'DSA_CATEGORY_SCAMS_AND_OR_FRAUD',
  DSA_CATEGORY_SELF_HARM = 'DSA_CATEGORY_SELF_HARM',
  DSA_CATEGORY_SCOPE_OF_PLATFORM_SERVICE = 'DSA_CATEGORY_SCOPE_OF_PLATFORM_SERVICE',
  DSA_CATEGORY_UNSAFE_AND_OR_ILLEGAL_PRODUCTS = 'DSA_CATEGORY_UNSAFE_AND_OR_ILLEGAL_PRODUCTS',
  DSA_CATEGORY_VIOLENCE = 'DSA_CATEGORY_VIOLENCE',
  DSA_CATEGORY_OTHER = 'DSA_CATEGORY_OTHER',
}

export interface DSAContext {
  userName?: string;
  userEmail?: string;
  contentType: Omit<DSAContentType, 'BIO'>;
  contentLocation: string;
  reason: string;
  profileImageId?: string;
  dsaCategory: DSACategoryType;
}

export interface MessageThreadReportDSAContext {
  dsaCategory: DSACategoryType;
  contentLocation: string;
  reason: string;
  userName?: string;
  userEmail?: string;
}

/**
 * 메세지 신고 요청 DTO
 * @see https://www.notion.so/hpcnt/DM-API-30ece00cd35480e489bfdc458526a4c6#30ece00cd354800aa4c0e69d5d80c440
 */
export interface MessageThreadReportRequest {
  messageThreadId: string;
  reportType: DMReportType;
  reason?: string;
  dsaContext?: MessageThreadReportDSAContext;
}

export interface ReportProfileCardRequest {
  cardType: DTOProfileCardType;
  cardId: string;
  reportType: ReportType | DMReportType;
  dsaContext?: Partial<DSAContext>;
}

export interface ReportEventParam {
  tab: string;
  page: string;
  target: string;
  target_id: string;
  target_detail: string | undefined;
}
